import Client from "../client/ApiClient"
const resource = "/api/v1"

const getGroups = () => Client.get(`${resource}/groups/`)

const createGroup = (data) => Client.post(`${resource}/groups/`, data)

const deleteGroup = (groupId) => Client.delete(`${resource}/groups/${groupId}/`)

const updateGroupName = (groupId, data) =>
  Client.put(`${resource}/groups/${groupId}/`, data)

const getVisiblePermission = (idGroup) =>
  Client.get(`${resource}/group/${idGroup}/permissions/visible/`)

const getCurrentPermission = (idGroup) =>
  Client.get(`${resource}/group/${idGroup}/permissions/`)

const updatePermission = (data, idGroup) =>
  Client.put(`${resource}/group/${idGroup}/permissions/`, data)

const getStaffs = (params) => Client.get(`${resource}/staffs/`, { params })

const createStaff = (data) => Client.post(`${resource}/staffs/`, data)

const updateStaff = (data, staffId) => Client.put(`${resource}/staff/${staffId}/`, data)

const deleteStaff = (staffId) => Client.delete(`${resource}/staff/${staffId}/`)

const PermissionRepository = {
  getGroups,
  createGroup,
  deleteGroup,
  updateGroupName,
  getVisiblePermission,
  getCurrentPermission,
  updatePermission,
  getStaffs,
  createStaff,
  updateStaff,
  deleteStaff
}
export default PermissionRepository
